import { Component } from '@angular/core';
import { SharedService } from '../../../../Services/shared.service';
import { API_End_Point } from '../../../../Services/API_End_Point';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ElementRef, ViewChild } from '@angular/core';
import * as faceapi from 'face-api.js';



@Component({
  selector: 'app-mychild',
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule],
  templateUrl: './mychild.component.html',
  styleUrl: './mychild.component.css'
})
export class MychildComponent {

  @ViewChild('CameraId') _camera!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvas') _canvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('frame') _frame!: ElementRef<HTMLDivElement>;
  PREP_UserInfo: any = null;
  capturedImage: string | null = null;
  faceCount: any = null;
  msg: any = null;
  isShowCamera: any = false;
  ChildList: any[] = [];
  object: any;
  isAddChild: boolean = false;
  isEdit: boolean = false;
  constructor(private _svc: SharedService, private _fb: FormBuilder, private _router: Router) {
    this._svc.get_Login_Status().subscribe(x => {
      this.PREP_UserInfo = x;
    })
  }

  ngOnInit() {
    if (this.PREP_UserInfo) {
      this.fetchChildList();
      this.GenerateForm();
    }

  }
  GenerateForm() {
    this.object = this._fb.group({
      id: [null],
      childName: [null, [Validators.required, Validators.minLength(2)]],
      classId: [null, [Validators.required]],
      photo: [null, [Validators.required]],
    });
  }
  fetchChildList(callback?: () => void) {
    this._svc.GET(API_End_Point.GetChild).subscribe((res: any) => {
      if (res && res.result === 'success') {
        this.ChildList = res.data;
        if (callback) callback();
        if (this.ChildList.length == 1) {
          this._svc.updateChildInfo(this.ChildList[0]);
        }
      } else {
        this.ChildList = [];
        if (callback) callback();
      }
    });
  }
  saveChildRecord() {
    

    if (this.object.invalid) {
      this.object.markAllAsTouched();
      this.object.markAsDirty();
      return;
    }
    if (this.ChildList.length >= 5 && this.object.value.id == null) {
      this._svc.Notification('error', 'You can only add up to 5 children.');
      return;
    }


    const childData = this.object.value;
    this._svc.POST(childData, API_End_Point.AddChild).subscribe((res: any) => {
      if (res && res.result === 'success') {
        if (childData.id && childData.id > 0) {
          this._svc.Notification("success", "Child updated successfully");
        } else {
          this._svc.Notification("success", "Child added successfully");
        }
        this.fetchChildList(() => {
          const activeChild = this.ChildList.find((c: any) => c.ActiveStudent === true);
          if (activeChild && activeChild.StudentId == childData.id) {
            this._svc.updateChildInfo(activeChild);
          }
        });
        this.object.reset();
        this.capturedImage = null;
        this.isShowCamera = false;
        this.isAddChild = false;
        this.ngOnDestroy();
      } else {
        this._svc.Notification("error", "Failed to add child. Please try again.");
      }
    });
  }
  Switch(childId: any) {
    debugger
    this._svc.GET(API_End_Point.switchChild(childId)).subscribe((res: any) => {
      if (res && res.result === 'success') {
        this._svc.Notification('success', 'Switched to child account successfully');
        this.fetchChildList(() => {
          const activeChild = this.ChildList.find((c: any) => c.ActiveStudent === true);
          if (activeChild && activeChild.StudentId == childId) {
            this._svc.updateChildInfo(activeChild);
          }
        });
      }
    });
  }
  Edit(childId: any) {
    const child = this.ChildList.find((c: any) => c.StudentId === childId);
    if (child) {
      this.object.patchValue({
        id: child.StudentId,
        childName: child.childName,
        classId: child.ClassId,
        photo: child.Photo,
        //  gender: child.Gender,
        ActiveStudent: child.activeStudent
      });
      this.isAddChild = true;
      this.isEdit = true
    }
  }












  openCamera(): void {
    this.capturedImage = null;
    this.isShowCamera = true
    this._svc.openCamera(this._camera);
  }

  async captureImage() {

    const canvas = this._canvas.nativeElement;
    const video = this._camera.nativeElement;
    const context = canvas.getContext('2d');

    if (context) {

      const top = this._frame.nativeElement.offsetTop;
      const left = this._frame.nativeElement.offsetLeft;
      const height = this._frame.nativeElement.offsetHeight;
      const width = this._frame.nativeElement.offsetWidth;

      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = video.videoWidth;
      tempCanvas.height = video.videoHeight;
      const tempCtx = tempCanvas.getContext('2d');
      tempCtx?.drawImage(video, 0, 0, tempCanvas.width, tempCanvas.height);


      // Crop from original size to match frame

      const cropX = left * (video.videoWidth / video.clientWidth);
      const cropY = top * (video.videoHeight / video.clientHeight);
      const cropWidth = width * (video.videoWidth / video.clientWidth);
      const cropHeight = height * (video.videoHeight / video.clientHeight);

      context.drawImage(tempCanvas, cropX, cropY, cropWidth, cropHeight, 0, 0, canvas.width, canvas.height);

      const detections = await faceapi.detectAllFaces(
        this._canvas.nativeElement,
        new faceapi.SsdMobilenetv1Options()
      );
      this.msg = "";
      if (detections.length == 1) {
        this.capturedImage = canvas.toDataURL('image/png'); // base64 image
        this.object.patchValue({ photo: this.capturedImage });
        this.ngOnDestroy()
      }

      else {
        this.msg = "Make sure you're visible in the camera frame.";
        this._svc.Notification('error', this.msg);
        this.capturedImage = null;
      }
    }
  }
  ngOnDestroy(): void {
    this.isShowCamera = false;
    this._svc.closeCamera();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this._svc.loadModels();
    }, 100);
  }








}